import { convertSnakeToCamel } from "@/app/infrastructures/misc/common-library/ConvertSnakeToCamel";
import { LoginApprovalDevicesList, LoginApprovalHistoryList, LoginApprovalList, LoginReviewBody, LoginReviewError, LoginReviewSuccess } from "@/domain/entities/ManagementLoginApproval";
import { ResponsePayloadV2 } from "@/domain/entities/ResponsePayload";
import { AxiosResponse } from "axios";

export class ManagementLoginApprovalMapper {
  // approval
  convertLoginApprovalListFromApi(res: AxiosResponse<any>): LoginApprovalList {
    const {
      data: { meta, data }
    } = res;

    return new LoginApprovalList({
      pagination: convertSnakeToCamel({
        ...meta,
        totalData: meta.total_records
      }),
      data: convertSnakeToCamel(data)
    });
  }

  convertLoginApprovalReviewErrorFromApi(res?: AxiosResponse<any>): LoginReviewError {
    if(!res) return new LoginReviewError({
      code: 500,
      message: {
        en: "Internal Server Error",
        id: "Internal Server Error"
      }
    })
    
    const {
      data: { meta, data }
    } = res;

    return new LoginReviewError({
      code: meta.code,
      message: convertSnakeToCamel(data)
    });
  }

  convertLoginApprovalReviewSuccessFromApi(res: AxiosResponse<any>): LoginReviewSuccess {
    const {
      data: { meta, data }
    } = res;

    return new LoginReviewSuccess({
      message: convertSnakeToCamel(data)
    });
  }

  // devices
  convertLoginApprovalDevicesListFromApi(res: AxiosResponse<any>): LoginApprovalDevicesList {
    const {
      data: { meta, data }
    } = res;

    return new LoginApprovalDevicesList({
      pagination: convertSnakeToCamel({
        ...meta,
        totalData: meta.total_records
      }),
      data: convertSnakeToCamel(data)
    });
  }

  convertLoginApprovalDeviceReviewErrorFromApi(res?: AxiosResponse<any>): LoginReviewError {
    if(!res) return new LoginReviewError({
      code: 500,
      message: {
        en: "Internal Server Error",
        id: "Internal Server Error"
      }
    })
    
    const {
      data: { meta, data }
    } = res;

    return new LoginReviewError({
      code: meta.code,
      message: convertSnakeToCamel(data)
    });
  }

  convertLoginApprovalDeviceReviewSuccessFromApi(res: AxiosResponse<any>): LoginReviewSuccess {
    const {
      data: { meta, data }
    } = res;

    return new LoginReviewSuccess({
      message: convertSnakeToCamel(data)
    });
  }

  // history
  convertLoginApprovalHistoryListFromApi(res: AxiosResponse<any>): LoginApprovalHistoryList {
    const {
      data: { meta, data }
    } = res;

    return new LoginApprovalHistoryList({
      pagination: convertSnakeToCamel({
        ...meta,
        totalData: meta.total_records
      }),
      data: convertSnakeToCamel(data)
    });
  }

  
  public convertFormDataFromApi(result: AxiosResponse<any>): ResponsePayloadV2 {
    const responseData = result.data;

    return new ResponsePayloadV2({ data: responseData });
  }
}
